import cmd, { BaseResponse } from '../../cmd';

export const deleteFavoritesList = (id: number): Promise<BaseResponse<boolean>> => {
  const params = { favoriteList: id };

  return cmd<boolean>({ cmd: 'deleteCustomerFavList', params });
};

export default deleteFavoritesList;
